import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConnectorStatus } from '../../_objects/connector';
import { HttpService } from "../http.service";
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class ConnectorService extends HttpService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  toggleConnector(connectorStatus: ConnectorStatus): Observable<void> {
    const endpoint = super.getEndpoint('connectors');
    return this.http.post<void>(endpoint, connectorStatus);
  }

  getConnectorStatus(connectorId: string): Observable<ConnectorStatus> {
    const endpoint = super.getEndpoint(`connectors/${connectorId}`);
    return this.http.get<ConnectorStatus>(endpoint);
  }
}
